import { createStore, compose, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import rootReducer from './root-reducer'

export default function configureStore (initialState) {
  const middleware = applyMiddleware(thunkMiddleware)
  /* istanbul ignore next */
  const middlewarePlusDevTools = window.devToolsExtension
    ? compose(middleware, window.devToolsExtension())
    : middleware

  return createStore(rootReducer, initialState, middlewarePlusDevTools)
}



// WEBPACK FOOTER //
// ./src/redux/configure-store.js